<txtb-drawer
  (contentCollapse)="controlVideoPlayback(!$event)"
  [actionId]="action.id"
  [textbookPageId]="action.textbookPageId"
  [textbookId]="action.textbookId"
  [groupInfo]="groupInfo"
>
  <div main class="video-wrapper">
    <txtb-media-player
      [playerLayout]="playerLayout"
      [playback$]="updatePlayback$ubject.asObservable()"
      [currentTime$]="updateCurrentTime$ubject.asObservable()"
      [controlsVisibility$]="updateControlsVisibility$ubject.asObservable()"
      [volume$]="updateVolume$ubject.asObservable()"
      [options]="videoOptions"
      (playerOnAfterViewInit)="onPlayerAfterViewInit()"
      (playerOnLoadedData)="onPlayerLoadedData()"
      (playerOnVolumeChange)="onPlayerVolumeChange($event)"
      (playerOnTimeUpdate)="onMediaCurrentTimeChange($event)"
      (playerOnPlaybackChange)="onPlayerPlaybackChange($event)"
      (playerOnEnded)="onPlayerEnded()"
    >
    </txtb-media-player>
  </div>
</txtb-drawer>
